import { Route, Routes as SwitchRoutes, useLocation } from "react-router-dom"
import { Header } from "./components/Header"
import { Footer } from "./components/Footer"
import { BackToTop } from "./components/BackToTop"
import "./index.css"
import Start from "./Start"
import {
  F_START_AGB,
  F_START_DATENSCHUTZ,
  F_START_EMAIL_VALIDATION,
  F_START_FORGOT_PASSWORD,
  F_START_IMPRESSUM,
  F_START_LOGIN,
  F_START_MINORINFO,
  F_START_RESET_PASSWORD,
} from "../../constants/routes"
import Login from "./Login/Login"
import ForgotPassword from "./ForgotPassword/ForgotPassword"
import ValidateEmail from "./ValidateEmail/ValidateEmail"
import AGB from "./Impressum/AGB"
import Datenschutz from "./Impressum/Datenschutz"
import Impressum from "./Impressum/Impressum"
import MinorInfo from "./Impressum/MinorInfo"
import CookieFormular from "./components/CookieFormular"
import ResetPassword from "./ForgotPassword/ResetPassword"

const StartRouter = () => {
  const location = useLocation()

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-white to-gray-50 text-gray-900">
      <Header />

      <SwitchRoutes location={location}>
        <Route path="/" element={<Start />} />
        <Route
          path={F_START_LOGIN}
          element={
            <section className="relative py-20">
              <Login />
            </section>
          }
        />

        <Route
          path={F_START_FORGOT_PASSWORD}
          element={
            <section className="relative py-20">
              <ForgotPassword />
            </section>
          }
        />

        <Route
          path={F_START_RESET_PASSWORD}
          element={
            <section className="relative py-20">
              <ResetPassword />
            </section>
          }
        />

        <Route
          path={F_START_EMAIL_VALIDATION}
          element={
            <section className="relative py-20">
              <ValidateEmail />
            </section>
          }
        />

        <Route
          path={F_START_AGB}
          element={
            <section className="relative p-20">
              <AGB />
            </section>
          }
        />

        <Route
          path={F_START_DATENSCHUTZ}
          element={
            <section className="relative p-20">
              <Datenschutz />
            </section>
          }
        />

        <Route
          path={F_START_IMPRESSUM}
          element={
            <section className="relative p-20">
              <Impressum />
            </section>
          }
        />

        <Route
          path={F_START_MINORINFO}
          element={
            <section className="relative p-20">
              <MinorInfo />
            </section>
          }
        />

        <Route path="*" element={<Start />} />
      </SwitchRoutes>

      <Footer />
      <BackToTop />
      <CookieFormular />
    </div>
  )
}

export default StartRouter
